import { ReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { AppState } from 'state/state.model';

import type { SidePanelTabId, SidePanelUiStateMap } from './sidePanelUi.model';

export function getActiveTabInSidePanel(state: SidePanelUiStateMap, tabId: string): SidePanelTabId {
  return (state && state[tabId]?.activeTab) ?? 'quotation';
}

export function getSidePanelMetadata(state: SidePanelUiStateMap, tabId: string) {
  return state[tabId]?.metadata;
}

export function getSidePanelQuoteDetailsFieldsMetadata(
  state: AppState,
  tabId: string,
): Readonly<Record<string, ReadonlyValueDefinition>> | undefined {
  return state.uiPanel?.sidePanelUi?.[tabId]?.fieldsMetadata;
}

export function selectIsBuySgSellsTradeWay(state: AppState, tabId: string) {
  const tradeWay = state.uiPanel?.sidePanelUi?.[tabId]?.metadata?.tradeWay ?? 'Sell';
  return tradeWay === 'Sell';
}
